import Config from '../utils/Config';

export default class Server {

    constructor(leanderApi, debug = false)
    {        
        this.debug = debug;
        this.onResponse = new Phaser.Signal();
        this.api = leanderApi;
    }

    __sendRequest(req, respMethod = '')
    {
        respMethod = [].concat(respMethod);
        return new Promise(handler.bind(this));

        function handler(res, rej)
        {
            const api = this.api;
            let eventId = api.subscribeToEvent(api.requestStatus.REQUEST_COMPLETED, (resp) =>
            {
                this.onResponse.dispatch(resp);

                if (!resp)
                {
                    return rej('Empty response.');
                }

                api.unsubscribeFromEvent(eventId);

                if (!resp.data || !resp.data.length)
                {
                    return rej('No response data.');
                }

                let errors = resp.data.filter((dataPart) =>
                    !!dataPart.errorCode ||
                    dataPart.status === 'ERROR' ||
                    dataPart.status === 'SERVER_ERROR'
                );
                if (errors && errors.length)
                {
                    return rej(errors);
                }

                let data = resp.data.filter((dataPart) => respMethod && respMethod.indexOf(dataPart.method) !== -1);
                if (respMethod[0].length>0 && !data.length) // ignore result if not the desired or the respMethod is empty
                {
                    return;
                }

                res(resp);
            });

            api.sendRequest(req);
        }
    }

    __publishEvent(event, loopbackEvent = '', ...rest)
    {
        return new Promise(handler.bind(this));

        function handler(res, rej)
        {
            const api = this.api;
            let eventId = api.subscribeToEvent(loopbackEvent || event, (resp) =>
            {
                if (!resp)
                {
                    return rej('Empty response.');
                }

                api.unsubscribeFromEvent(eventId);

                let data = ( resp.data instanceof Array ? resp.data : resp.data instanceof Object ? [resp.data] : [] );
                let errors = data.filter((dataPart) => !!dataPart.errorCode);
                if (errors && errors.length)
                {
                    return rej(errors);
                }

                res(resp);
            });

            let args = [event].concat(rest);
            api.publishEvent.apply(api, args);
        }
    }

    throwError(code)
    {
        const error = { data: code, error: { code }};
        
        return this.__publishEvent( 
            leanderGMApi.publications.ERROR_OCCURRED, 
            leanderGMApi.publications.ERROR_HANDLED,
            error
        )
        .then(() =>
        {
            console.log('throwError handled');
            return Promise.resolve(code);
        })
        .catch((err) =>
        {
            console.error('throwError error', err);
            return Promise.reject(err);
        });
    }
    
    init()
    {
        const api = this.api;
        const req = [{
            'method': 'initializeGame',
            'params': {
                'sessionId': '',
                'languageId': Config.locale
            }
        }];

        return this.__sendRequest(req, 'initializeGame').then((resp) =>
        {
            console.log('initializeGame', resp);
            return this.__publishEvent(
                api.publications.INITIALIZED,
                api.publications.INITIALIZED_CONFIRMED
            ).then((resp2) =>
            {
                return Promise.resolve(resp);
            }).catch((err) =>
            {
                return Promise.reject(err);
            });
        }).catch((err) =>
        {
            console.error('init', err);
            return Promise.reject(err);
        });
    }

    autoSpinConfirmation(spins, totalBetList)
    {
        return new Promise((resolve, reject) =>
        {
            const api = this.api;
            let confirmEventId, cancelEventId;

            confirmEventId = this.subscribe(api.publications.AUTOPLAY_ACTIVATED_CONFIRMATION, (resp) =>
            {
                this.unsubscribe(confirmEventId);
                this.unsubscribe(cancelEventId);

                //reject(resp);
                resolve(resp);
            });

            cancelEventId = this.subscribe(api.publications.AUTOPLAY_ACTIVATED_CANCELLATION, (resp) =>
            {
                this.unsubscribe(confirmEventId);
                this.unsubscribe(cancelEventId);

                reject(resp);
            });

            this.publish(api.publications.AUTOPLAY_ACTIVATED_GAME, {spins, totalBetList});
        });
    }

    playRequest()
    {
        return new Promise((resolve, reject) =>
        {
            let timerId = setTimeout(() => reject(), 500);
            
            const api = this.api;
            let eventId = api.subscribeToEvent(api.publications.PLAY_CONFIRMED, (resp) =>
            {
                clearTimeout(timerId);
                
                api.unsubscribeFromEvent(eventId);
                
                let errors = (resp.data || []).filter((dataPart) => !!dataPart.errorCode);
                if (errors && errors.length)
                {
                    return reject(errors);
                }
                                
                resolve();
            });
            
            api.publishEvent(api.publications.PLAY_REQUEST);
        });
    }    
    
    bet(stake, debugHash = '', paramsToSave = null)
    {
        const req = [{
            'method': 'openPlay',
            'params': { 'sessionId': '' }
        }, {
            'method': 'placeBet',
            'params': {
                'params': {
                    'option': 'bet',
                    'bet': stake * Config.NUMBER_OF_LINES,
                    'method': 'spin',
                    'linesPlayed': Config.NUMBER_OF_LINES
                },
                'sessionId': '',
                'type': 'spin',
                'bet': stake * Config.NUMBER_OF_LINES
            }
        },
        {
            'method': 'getBetResult',
            'params': {
                'sessionId': '',
                'debug': debugHash ? { 'random': debugHash } : null
            }
        }];

        if (paramsToSave)
        {
            for (let key in paramsToSave)
            {
                req.push({
                    method: 'saveData',
                    params: {
                        data: paramsToSave[key],
                        name: key,
                        'sessionId': ''
                    }
                });
            }
        }

        this.setGameState(this.api.gameStates.OPEN_PLAY);

        return this.__sendRequest(req)
            .then((resp) =>
            {
                console.log('bet', resp);
                return Promise.resolve(resp);
            })
            .catch((err) =>
            {
                console.error('bet', err);
                return Promise.reject(err);
            });
    }

    saveData(data)
    {
        if (!data || typeof data !== 'object' || !Object.keys(data).length)
        {
            return Promise.resolve();
        }

        const req = [];
        for (let key in data)
        {
            req.push({
                method: 'saveData',
                params: {
                    data: data[key],
                    name: key,
                    'sessionId': ''
                }
            });
        }

        return this.__sendRequest(req)
            .then((resp) =>
            {
                console.log('saveData', resp);
                return Promise.resolve(resp);
            })
            .catch((err) =>
            {
                console.error('saveData', err);
                return Promise.reject(err);
            });
    }

    closePlay(playId)
    {
        const req = [{
            method: 'settlePlay',
            params: { 
                sessionId: '', 
                playId: playId
            }
        }, {
            method: 'closePlay',
            params: { 
                sessionId: '', 
                playId: playId
            }
        }];

        this.setGameState(this.api.gameStates.SETTLE_PLAY);

        return this.__sendRequest(req)
            .then((resp) =>
            {
                console.log('closePlay', resp);
                return Promise.resolve(resp);
            })
            .catch((err) =>
            {
                console.error('closePlay', err);
                return Promise.reject(err);
            });
    }
     
    changeMusic(music)
    {
        return this.publish(this.api.publications.MUSIC_STATUS_CHANGED_GAME, music);
    }
    
    changeSound(sound)
    {
        return this.publish(this.api.publications.SOUND_EFFECTS_STATUS_CHANGED_GAME, sound);
    }

    publish(event, value)
    {
        return this.api.publishEvent.apply(this.api, arguments);
    }
    
    unsubscribe(eventId)
    {
        return this.api.unsubscribeFromEvent(eventId);
    }

    subscribe(event, callback)
    {
        return this.api.subscribeToEvent(event, callback);
    }

    goToLobby()
    {
        this.publish(this.api.publications.GAME_READY_FOR_UNLOAD);
        this.api.goToLobby();             
    }

    getSound()
    {
        return this.api.getSfxActive();
    }
    
    getMusic()
    {
        return this.api.getMusicActive();
    }
    
    changeOptions(open)
    {
        return this.publish(this.api.publications.CONTROL_PANEL_STATUS_CHANGED_GAME, open);
    }
    
    isBlocked()
    {
        return this.api.isGUIBlocked();
    }
    
    setGameState(state)
    {
        return this.publish(this.api.publications.GAME_STATUS_CHANGED, state);
    }    
}
